import NotAuthenticatedError from 'common/errors/NotAuthenticatedError';
import React, { createContext, useContext } from 'react';
import useLocalStorage from '../hooks/useLocalStorage';

/**
 * Global authentication context.
 */
export const AuthenticationContext = createContext();

/**
 * Global authentication context provider.
 *
 * @param {object} props Properties passed to the provider.
 */
export function AuthenticationProvider({ children }) {
  const [currentUser, setCurrentUser] = useLocalStorage('user', null);

  function isAuthenticated() {
    return currentUser !== null;
  }

  function isSystemAdmin() {
    if(isAuthenticated && currentUser.systemAdmin && !currentUser.actingOnBehalfOf){
      window.location.replace(`https://${window.location.host}/admin`);
    }
    return currentUser?.systemAdmin ?? false;
  }

  function getMerchantUuid() {
    return !isSystemAdmin() ? currentUser?.parties[0]?.uuid ?? '' : currentUser?.actingOnBehalfOf.uuid ?? '';
  }

  function getMerchantName() {
    return !isSystemAdmin() ? currentUser?.parties[0]?.name ?? '' : currentUser?.actingOnBehalfOf.name ?? '';
  }

  function reset() {
    setCurrentUser(null);
  }

  return (
    <AuthenticationContext.Provider value={{ currentUser, setCurrentUser, isAuthenticated, reset, getMerchantUuid, isSystemAdmin, getMerchantName }}>
      {children}
    </AuthenticationContext.Provider>
  );
}

/**
 * Convenience hook providing {@see AuthenticationContext} to function components.
 */
export function useAuthentication() {
  return useContext(AuthenticationContext);
}
